module.exports = __webpack_public_path__ + "static/media/Dog-with-Tulips---Pastel.5f597dd8.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/img/thumbnails/Dog-with-Tulips---Pastel.jpg
 ** module id = 430
 ** module chunks = 0
 **/